import React, { FC } from 'react';

import { connect } from 'react-redux';
import { IRootReducers } from 'src/reducers';
import { isProfileCompleted } from 'utils';

const mapStateToProps = (state: IRootReducers) => {
  return {
    showNotification: !isProfileCompleted(state.auth.user?.actionList || []),
  };
};

interface OwnProps {
  position: 'lateral-menu' | 'icon' | 'text';
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const NotificationDot: FC<Props> = ({ position, showNotification }) => {
  const dotClassName = `dot-notification dot-notification__${position}`;

  if (!showNotification) return <React.Fragment />;

  return <div className={dotClassName} />;
};

export default connect(mapStateToProps)(NotificationDot);
